import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { UPDATE_USER_PROFILE_BASIC_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import { PROFILE_BASIC_TAGS } from './getProfileBasic';
import type { UpdateBasicProfilePayload, UpdateBasicProfileResult } from '../types/updateProfileBasic.types';

export const updateProfileBasic = (builder: BuilderType) =>
  builder.mutation<UpdateBasicProfileResult, UpdateBasicProfilePayload>({
    invalidatesTags: [PROFILE_BASIC_TAGS],
    query: (body) => ({
      data: body,
      isErrMsgConcatErrCode: false,
      method: 'POST',
      url: UPDATE_USER_PROFILE_BASIC_URL,
    }),
    transformResponse: (response: GenericApiResponse<UpdateBasicProfileResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
